import { cx } from '@emotion/css';
import type { ElementType, FC, HTMLProps } from 'react';

interface Props extends HTMLProps<HTMLDivElement> {
  /**
   * HTML tag to use
   * @default 'div'
   */
  tag?: ElementType;
  /** Remove bottom margin */
  noMargin?: boolean;
}

/**
 * Group form elements with consistent spacing
 */
export const ODSFormGroup: FC<Props> = ({
  tag: Tag = 'div',
  noMargin,
  className,
  ...attributes
}) => {
  const tagProps = attributes as HTMLProps<HTMLElement>;

  if (noMargin) {
    tagProps.className = className;
  } else {
    tagProps.className = cx('mb-3', className);
  }

  return <Tag {...tagProps} />;
};

export default ODSFormGroup;
